import { MapsOnboarding } from "@/components/Elemnt/Onboarding/MapsOnboarding";
import { useParams } from "react-router";

const MapsOnboardingPage = () => {
  const { appToken = "" } = useParams();
  return <MapsOnboarding appToken={appToken} />;
};

export default MapsOnboardingPage;
